export default __webpack_public_path__ + "static/media/mulai.dfb449bc.png";